import { apiClient } from './client';
import { isAxiosError } from 'axios';

// Типы для глобального поиска
export type SearchType = 'customer' | 'building' | 'device';

export interface SearchResult {
  id: number;
  type: SearchType;
  title: string;
  subtitle: string;
  url: string;
}

export interface SearchResponse {
  results: SearchResult[];
  total: number;
}

// Параметры поиска
export interface SearchParams {
  q: string;     // Поисковый запрос (минимум 3 символа)
  limit?: number; // Количество результатов (по умолчанию 10)
}

/**
 * API для глобального поиска по системе
 */
export const searchApi = {
  /**
   * Глобальный поиск по клиентам, домам и устройствам
   * @param params - параметры поиска
   * @returns результаты поиска
   */
  globalSearch: async (params: SearchParams): Promise<SearchResponse> => {
    const { q, limit = 10 } = params;
    
    console.log('🌐 API searchApi.globalSearch вызван:', { q, limit });
    
    try {
      const response = await apiClient.get<SearchResponse>('/search', {
        params: { q, limit },
      });
      
      console.log('✅ API Response:', {
        status: response.status,
        data: response.data,
        total: response.data?.total,
        resultsCount: response.data?.results?.length
      });
      
      return response.data;
    } catch (error: unknown) {
      if (isAxiosError(error)) {
        console.error('❌ API Error:', {
          message: error.message,
          response: error.response?.data,
          status: error.response?.status,
        });
      } else {
        console.error('❌ API Error:', error);
      }
      throw error;
    }
  },
};

